import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M18.546 8.212a4.479 4.479 0 1 0-.056 6.389 1 1 0 0 1 .11-.11 4.48 4.48 0 0 0-.054-6.28m1.864 6.925a6.28 6.28 0 0 0-9.471-8.198 6.279 6.279 0 0 0 8.198 9.471l2.226 2.226a.9.9 0 1 0 1.273-1.273zM2.1 7a.9.9 0 0 1 .9-.9h5a.9.9 0 1 1 0 1.8H3a.9.9 0 0 1-.9-.9m0 5a.9.9 0 0 1 .9-.9h3a.9.9 0 1 1 0 1.8H3a.9.9 0 0 1-.9-.9m0 5a.9.9 0 0 1 .9-.9h5a.9.9 0 1 1 0 1.8H3a.9.9 0 0 1-.9-.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }